import { render, staticRenderFns } from "./PokedexView.vue?vue&type=template&id=2def4e1e&scoped=true"
import script from "./PokedexView.vue?vue&type=script&lang=js"
export * from "./PokedexView.vue?vue&type=script&lang=js"
import style0 from "./PokedexView.vue?vue&type=style&index=0&id=2def4e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def4e1e",
  null
  
)

export default component.exports